<template>

<div>

    <h1>Create new discount</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createDiscount">

        <DiscountFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create discount</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import DiscountFields from '@/components/DiscountFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'DiscountCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      discount: {},
      errors: null
    }
  },
  components: {
    DiscountFields,
    Errors
  },
  methods: {
    createDiscount () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'discounts', {
        method: 'POST',
        body: JSON.stringify(this.discount),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'discount-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
